import $ from 'jquery'

$(document).on('submit', '.js-ajax-form', function(e) {
  var $t = $(this)
  $t.find('.js-ajax-form__error').remove()
  $.ajax({
    type: 'POST',
    dataType: 'json',
    url: wpscuba.ajax,
    data: $t.serialize(),
    success: function(data) {
      $t.find('.js-ajax-form__error').remove()
      if (data.error) {
        $t.prepend(
          '<div class="o-form__row js-ajax-form__error">' +
            data.message +
            '</div>'
        )
      }
      if (data.requiredfield) {
        $(
          '<div class="js-ajax-form__error">' + data.message + '</div>'
        ).insertBefore($t.find("[name='" + data.requiredfield + "']"))
      }
      if (data.reload) {
        document.location.reload()
      }
    }
  })
  e.preventDefault()
})

$(document).on('click', '.js-ajax-form__submit', function(e) {
  $(this)
    .closest('.js-ajax-form')
    .submit()
  e.preventDefault()
})



// WEBPACK FOOTER //
// ./scripts/components/Form.js